import { IMotivoProblema } from "../../../Interfaces/AssistenciaTecnica/MotivoProblema/MotivoProblemaInterfaces";
import {
    AtualizarMotivoProblemaService,
    DeletarMotivoProblemaService,
    InserirMotivoProblemaService,
    ListarMotivoProblemaService,
    ListarMotivoProblemaWebService,
} from "../../../Services/AssistenciaTecnica/MotivoProblema/MotivoProblemaServices";
import { Controller } from "../../Controller";

export function ListarMotivoProblemaController() {
    return Controller(ListarMotivoProblemaService());
}

export async function InserirMotivoProblemaController(
    requestBody: IMotivoProblema
) {
    return Controller(InserirMotivoProblemaService(requestBody));
}

export async function DeletarMotivoProblemaController(
    idMotivoProblema: number
) {
    return Controller(DeletarMotivoProblemaService(idMotivoProblema));
}

export async function AtualizarMotivoProblemaController(
    requestBody: IMotivoProblema
) {
    return Controller(AtualizarMotivoProblemaService(requestBody));
}
export function ListarMotivoProblemaWebController() {
    return Controller(ListarMotivoProblemaWebService());
}
